/**
 * Coerces a number field value on blur into a numeric form value.
 */
export function coerceNumberFieldValue(raw: number | string): number | '' {
  if (raw === '' || raw === '-' || raw === '.') {
    return '';
  }
  const normalized = typeof raw === 'number' ? String(raw) : raw;
  const parsed = Number(normalized);
  return Number.isNaN(parsed) ? '' : parsed;
}

/**
 * Parses number field text while typing. Preserves in-progress decimals (e.g. `1.`) unless integer-only.
 */
export function parseNumberFieldInput(raw: string, integerOnly: boolean): number | string {
  if (raw === '') {
    return '';
  }

  if (integerOnly) {
    const parsed = parseInt(raw, 10);
    return Number.isNaN(parsed) ? '' : parsed;
  }

  if (raw === '-' || raw === '.') {
    return raw;
  }

  if (/^-?\d+\.$/.test(raw) || /^-?\.$/.test(raw)) {
    return raw;
  }

  const parsed = Number(raw);
  return Number.isNaN(parsed) ? '' : parsed;
}
